module.exports = __webpack_public_path__ + "assets/fd51375f39b462d9ae06d9d9623f48e5.mp3";